import { REFRESH_PROJECT_MOODBOARD, UPDATE_PROJECT_MOODBOARD } from '../constants/moodboard';

export function refreshProjectMoodboard(project) {
  return {
    type: REFRESH_PROJECT_MOODBOARD,
    payload: { project },
  };
}

export function updateProjectMoodboard(moodboard) {
  return {
    type: UPDATE_PROJECT_MOODBOARD,
    payload: { moodboard },
  };
}



// WEBPACK FOOTER //
// ./app/javascript/design/actions/moodboard.js